/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerReportQueryResponse, IncidentInvestigationControllerReportPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerReport";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerReport } from "../../clients/incident-agentService/incidentInvestigationControllerReport";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerReportQueryKey = (id: IncidentInvestigationControllerReportPathParams["id"]) => [{
  url: '/api/v1/incident-agent/investigations/:id/report',
  params: {
    id: id
  }
}] as const;
export type IncidentInvestigationControllerReportQueryKey = ReturnType<typeof incidentInvestigationControllerReportQueryKey>;
export function incidentInvestigationControllerReportQueryOptions(id: IncidentInvestigationControllerReportPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerReportQueryKey(id);
  return queryOptions<IncidentInvestigationControllerReportQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerReportQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerReport(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/report}
 */
export function useIncidentInvestigationControllerReport<TData = IncidentInvestigationControllerReportQueryResponse, TQueryData = IncidentInvestigationControllerReportQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerReportQueryKey>(id: IncidentInvestigationControllerReportPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerReportQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerReportQueryKey(id);
  const query = useQuery({
    ...incidentInvestigationControllerReportQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}